export default {
  FILTER_COMPETENCY_LIST: 'FilterCompetencyList',
  LOAD_COMPETENCY_LIST: 'LoadCompetencyList',
  LOAD_COMPETENCY_LIST_START: 'LoadCompetencyListStart',
  LOAD_COMPETENCY_LIST_END: 'LoadCompetencyListEnd',
  SEARCH_COMPETENCY_LIST_FILTER_STUDY_PROGRAM_START: 'SearchCompetencyListFilterStudyProgramStart',
  SEARCH_COMPETENCY_LIST_FILTER_STUDY_PROGRAM_END: 'SearchCompetencyListFilterStudyProgramEnd',
  TOGGLE_COMPETENCY_LIST_CONFIRM_DIALOG: 'ToggleCompetencyListConfirmDialog',
  SORT_COMPETENCY_LIST: 'SortCompetencyList'
};